//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import { Container } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import SimpleBar from 'simplebar-react';

// images

// icon

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
// import { LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../common/elemental/AfitdPageHead';
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import TopNav from '../topNav/TopNav';
import Footer from '../home/subComponents/Footer';
// import AfitdButton from '../common/elemental/AfitdButton';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import cardImg1 from '../images/FAQ/Rectangle 202.png';
// import cardImg2 from '../images/FAQ/Rectangle 2021.png';
// import cardImg3 from '../images/FAQ/Rectangle 2022.png';
import Article1 from '../images/ResourceCenter/Article 1 Thumbnail.jpeg';
import Article2 from '../images/ResourceCenter/Article 2 Thumbnail Image for Main Page.jpeg';
import Article3 from '../images/ResourceCenter/Article 3 Thumbnail Image for Main Page.jpeg';
import Article4 from '../images/ResourceCenter/Article 4 Thumbnail Image for Main Page.jpeg';
import Article5 from '../images/ResourceCenter/Article 5 Thumbnail Image for Main Page.jpeg';
import { PAGE_TITLE_RESOURCE_CENTER } from '../common/constants';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// fake Data: added by ansar
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        padding: 0,
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
    },
    pageContainer: { backgroundColor: 'white', overflow: 'hidden', height: '100%', minHeight: '100%', flexWrap: 'unset' },
    pageHeader: {
        maxHeight: '81px',
        // [theme.breakpoints.down('md')]: { maxHeight: '134px' }, // commented out because no more second row menu -el 20221022
        // [theme.breakpoints.down('sm')]: { maxHeight: '81px' },
    },
    pageContent: {
        flex: 1,
        overflowY: 'auto',
        // overflowX: 'hidden',
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    jobCenterLeft: { height: '100%', paddingTop: '25px' },
    jobCenterRight: { height: '100%', overflowY: 'hidden', flexWrap: 'unset', paddingTop: '35px', minHeight: '600px' },
    headingContainer: { textAlign: 'center', color: ' #000000', marginTop: 70 },
    textColour: { color: '#111E14' },
    cardTextStyle: { padding: '10px' },
    submitButton: { textTransform: 'capitalize', padding: '17px 44px', fontSize: '18px' },
    buttonContainer: { textAlign: 'center', paddingTop: 48, paddingBottom: 131 },
    resourceCard: { maxWidth: '353px', border: '1px solid #D5D7DD', borderRadius: '8px', margin: '10px', boxSizing: 'border-box' },
    resourceCardImage: { width: '100%' },
    likesViewText: { marginLeft: '9px', marginTop: '2px' },
    likeIcon: { color: 'rgba(17, 30, 20, 0.4)' },
    card: { width: '352px', borderRadius: '8px', border: '1px solid #D5D7DD', '&:hover': { cursor: 'pointer' } },
    cardContainer: {
        marginTop: '60px',
        [theme.breakpoints.up('lg')]: { maxWidth: 1024, margin: 'auto' },
        [theme.breakpoints.down('md')]: { maxWidth: 673, margin: 'auto' },
    },
    cardContent: { marginBottom: '27px', marginLeft: '24px', marginRight: '20px', borderBottom: '20px solid white' },
    cardHeading: { fontSize: '26px', fontWeight: 'bold', lineHeight: '34px' },
    cardParagraph: { fontSize: '15px', fontWeight: 400, lineHeight: '24px' },
    cardSocial: { display: 'flex', alignItems: 'center', marginTop: '20px' },
    cardSocialText: { marginLeft: '9px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    cardSection: { display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: 16 },
    dateTime: { marginBottom: 0, marginTop: '24px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    img: { width: '100%' },
    headingPara: { fontSize: 20 },
    headingTitle: { fontSize: 42 },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes } = params;

    const defns = {
        pageContainer: { container: true, direction: 'column' },
        pageHeader: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        pageContent: { item: true, container: true },
        tempContainer: { item: true, container: true, direction: 'column' },
        submitButton: { variant: 'contained', color: 'secondary' },
        cardContainer: { container: true },
        resourceCard: { item: true, md: 4 },
        likesViewContainer: { container: true, direction: 'row' },
        likesViewItem: { item: true },
        cardSection: { item: true, lg: 4, md: 6, sm: 12, xs: 12 },
        cardIcon: { color: 'rgba(17, 30, 20, 0.4)' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ResourceCenterLayout = props => {
    // resource center data

    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { isShowJobs } = props;
    let history = useHistory();

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleCardClick1 = () => {
        history.push('/resource-center/1');
    };
    const handleCardClick2 = () => {
        history.push('/resource-center/2');
    };
    const handleCardClick3 = () => {
        history.push('/resource-center/3');
    };
    const handleCardClick4 = () => {
        history.push('/resource-center/4');
    };
    const handleCardClick5 = () => {
        history.push('/resource-center/5');
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.pageContainer}>
            <AfitdPageHead title={PAGE_TITLE_RESOURCE_CENTER} />
            <Grid {...defns.pageHeader}>
                <TopNav />
            </Grid>
            <Grid {...defns.pageContent}>
                <SimpleBar style={{ height: '100%', width: '100%', flex: 1, overflowX: 'hidden' }}>
                    <Grid {...defns.tempContainer}>
                        <div {...defns.root}>
                            <Container style={{ flex: 'auto' }}>
                                <Grid {...defns.headingContainer}>
                                    <h1 {...defns.headingTitle}>Resource Center</h1>
                                    <p {...defns.headingPara}>Advice and cheat codes for job seekers</p>
                                </Grid>

                                {/* card section */}

                                <Grid {...defns.cardContainer}>
                                    <Grid {...defns.cardSection}>
                                        <div {...defns.card} onClick={handleCardClick1}>
                                            <div {...defns.imageContainer}>
                                                <img {...defns.img} src={Article1} alt="" />
                                            </div>
                                            <div {...defns.cardContent}>
                                                <p {...defns.dateTime}>5 min read</p>
                                                <h3 {...defns.cardHeading}>How To Create a Modern Resume Like a Boss</h3>
                                                <p {...defns.cardParagraph}>
                                                    Let’s be real; creating a resume is probably not at the top of your favorite things todo list. It is, however, probably near the
                                                    top...
                                                </p>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid {...defns.cardSection}>
                                        <div {...defns.card} onClick={handleCardClick2}>
                                            <div {...defns.imageContainer}>
                                                <img {...defns.img} src={Article2} alt="" />
                                            </div>
                                            <div {...defns.cardContent}>
                                                <p {...defns.dateTime}>6 min read</p>
                                                <h3 {...defns.cardHeading}>Interviews: Let’s Nail It!.</h3>
                                                <p {...defns.cardParagraph}>
                                                    For new job seekers and old pros alike the interview process can be one of the more anxiety-inducing aspects of procuring new...
                                                </p>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid {...defns.cardSection}>
                                        <div {...defns.card} onClick={handleCardClick3}>
                                            <div {...defns.imageContainer}>
                                                <img {...defns.img} src={Article3} alt="" />
                                            </div>
                                            <div {...defns.cardContent}>
                                                <p {...defns.dateTime}>6 min read</p>
                                                <h3 {...defns.cardHeading}>Dress For Success: Is that still a thing?</h3>
                                                <p {...defns.cardParagraph}>
                                                    “Dress for Success,” might seem like a cliché from your grandparent’s day, and to an extent it is, but the phrase still holds
                                                    some relevance...
                                                </p>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid {...defns.cardSection}>
                                        <div {...defns.card} onClick={handleCardClick4}>
                                            <div {...defns.imageContainer}>
                                                <img {...defns.img} src={Article4} alt="" />
                                            </div>
                                            <div {...defns.cardContent}>
                                                <p {...defns.dateTime}>8 min read</p>
                                                <h3 {...defns.cardHeading}>Working from Home: Where Productivity meets Balance</h3>
                                                <p {...defns.cardParagraph}>
                                                    Working remotely will most likely be a part of the new normal in a post-pandemic world. There are many benefits to telework, but
                                                    there are also a few downsides...
                                                </p>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid {...defns.cardSection}>
                                        <div {...defns.card} onClick={handleCardClick5}>
                                            <div {...defns.imageContainer}>
                                                <img {...defns.img} src={Article5} alt="" />
                                            </div>
                                            <div {...defns.cardContent}>
                                                <p {...defns.dateTime}>8 min read</p>
                                                <h3 {...defns.cardHeading}>ACTION! Making Your AFITD Profile Video</h3>
                                                <p {...defns.cardParagraph}>
                                                    One of the most bangin’ features A Foot in the Door offers our members is the opportunity to create a profile video. This
                                                    element of the platform...
                                                </p>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>

                                {/* <Grid {...defns.cardContainer}>
                        </Grid> */}

                                {/* <Grid {...defns.buttonContainer}>
                                <AfitdButton {...defns.submitButton}>Load more</AfitdButton>
                            </Grid> */}
                            </Container>
                            <Footer />
                        </div>
                    </Grid>
                </SimpleBar>
            </Grid>
        </Grid>
    );
};

export default ResourceCenterLayout;
